import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import UserRoles from "constants/UserRoles";

const breadcrumbsStatic = [{
	name: 'Customer Log',
	url: '/customers/logs',
	icon: 'archive',
}];

export default class CustomersLogs extends Framework.Components.View {

	render() {
		let {history,roles} = this.props;

		return (
			<div className="container-fluid">

				<Collections.LogsCustomer
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

			</div>
		);
	}
}

